
<template>
  <div id="page-data-view">

    <vx-card title="Template Details" class="mb-base">

      <!-- Avatar -->
      <div class="vx-row">

        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">Name</td>
              <td>{{ view_data.name }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Color</td>
              <td>{{ view_data.amenity_color }}</td>
            </tr>
            <tr>
              <td class="font-semibold"></td>
              <td><vs-input class="w-full h-10 rounded-lg mb-8" v-model="view_data.amenity_color" type="color" name="amenity_color" disabled/></td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->

        <!-- Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">Property</td>
              <td v-if="view_data.property !== undefined">{{ view_data.property.name }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Updated</td>
              <td>{{ new Date(view_data.updatedAt) | date(true) }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Created</td>
              <td>{{ new Date(view_data.createdAt) | date(true) }}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 2 -->

        <div class="vx-col w-full flex" id="account-manage-buttons">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-amenity-edit', params: { editId: $route.params.viewId }}" 
          :disabled="!showU">Edit <!-- crud -->
          </vs-button> 
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" 
          :disabled="!showD">Delete <!-- crud -->
          </vs-button>          
        </div>

      </div>

    </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Other Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Min Time</td>
                <td>{{ view_data.min_hours }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Max Time</td>
                <td>{{ view_data.max_hours }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Buffer Time</td>
                <td>{{ view_data.buffer_time }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Booking Limit</td>
                <td>{{ view_data.booking_limit }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Booking Limit Unit</td>
                <td v-if="view_data.freq !== undefined">{{ view_data.freq.val }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Deposit</td>
                <td>{{ view_data.deposit_amount }}</td>
              </tr>               
            </table>
          </vx-card>
        </div> 

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Notification" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Booking Message</td>
                <td>{{ view_data.booking_message }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Terms and Conditions</td>
                <td>{{ view_data.terms_conditions }}</td>
              </tr>
            </table>
          </vx-card>
        </div> 
        
      </div>        

    <vx-card title="Images" class="mb-base">
      <!-- Avatar -->
      <div class="vx-row">
        <!-- Information - Col 1 -->
        <!-- reading docs -->
        <div class="vx-col flex-1">
          <div class="flex items-start flex-col sm:flex-row">
            <div v-if="files.length > 0" v-for="(item, file) in files">
              <span class="flex">                
                <img :src="item"  class="mt-4 mr-8 rounded h-24 w-24" @click="showMultiple(file)" />
              </span>
            </div>
            <p v-if="files.length == 0">No files uploaded</p>
          </div>
        </div>
        <!-- /Information - Col 1 -->
      </div>
    </vx-card>

    <!-- Content Row -->
    <vx-card class="mb-base">
        <div class="vx-col w-full">      
          <div class="flex items-end md:mt-8">
            <feather-icon icon="CalendarIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Hours of Operation</span>
          </div>
          <div class="vx-row w-full mt-4">
            <div class="w-full vx-col">
              <vs-table stripe :data="optionHours" :class="{'hours-of-operation':hopErr}">
                <template slot="thead">
                  <vs-th>Day</vs-th>
                  <vs-th>24 Hours</vs-th>
                  <vs-th>Operational Hours</vs-th>
                </template>

                <template>
                  <vs-tr v-for="(currentD, indexD) in optionOperationalDays" :key="indexD">
                    <vs-td>{{currentD.name}}</vs-td>
                    <vs-td>
                      <vs-switch vs-icon-on="check" v-model="view_data.operational_days_json[indexD]['is_all_day']" color="warning" vs-value="m-yes" disabled>
                        <span slot="off"></span>
                      </vs-switch>
                    </vs-td>
                    <vs-td>
                      <vs-chip color="#24c1a0" v-for="(current, index) in view_data.operational_days_json[indexD]['val']" :key="index">
                        {{current}}
                      </vs-chip>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>        
            </div>
          </div>       
        </div>
    </vx-card> 

    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.viewId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-amenity-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

    <vue-easy-lightbox
      :visible="visible"
      :imgs="files"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>

  </div>
</template>

<script>
import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud

export default {
  components: {
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      imgs: '',  // Img Url , string or Array of string
      visible: false,
      index: 0,   // default: 0

      token: token,

      optionHours: [
        { id:'1', name: 'None' },
        { id:'2', name: '15 Mins' },
        { id:'3', name: '30 Mins' },
        { id:'4', name: '45 Mins' },   
        { id:'5', name: '1 Hour' },
        { id:'6', name: '2 Hours' },
        { id:'7', name: '3 Hours' },
        { id:'8', name: '4 Hours' },
        { id:'9', name: '5 Hours' },
        { id:'10', name: '6 Hours' },
        { id:'11', name: '7 Hours' },
        { id:'12', name: '8 Hours' }
      ],

      optionOperationalDays: [
        { id:'0', name: 'Sunday' },
        { id:'1', name: 'Monday' },
        { id:'2', name: 'Tuesday' },
        { id:'3', name: 'Wednesday' },
        { id:'4', name: 'Thursday' },
        { id:'5', name: 'Friday' },
        { id:'6', name: 'Saturday' }
      ],
      //amenity
      view_data: {
        name: '',
        max_hours: '',
        is_deposit_required: '',
        amount: '',
        is_key_required: '',
        approved_color: '',
        requested_color: '',
        blocked_color: '',
        amenity_color: '',
        buffer_time: '',
        available_from_time: '',
        available_to_time: '',
        deposit_amount: '',
        booking_message: '',
        terms_conditions: '',
        min_hours: '',
        inventory_items_json: [],
        is_all_day: '',
        operational_days_json: [      
          { id:'1', val: [], op_start_time:[], op_end_time:[], is_all_day:false },
          { id:'2', val: [], op_start_time:[], op_end_time:[], is_all_day:false },
          { id:'3', val: [], op_start_time:[], op_end_time:[], is_all_day:false },
          { id:'4', val: [], op_start_time:[], op_end_time:[], is_all_day:false },
          { id:'5', val: [], op_start_time:[], op_end_time:[], is_all_day:false },
          { id:'6', val: [], op_start_time:[], op_end_time:[], is_all_day:false },
          { id:'7', val: [], op_start_time:[], op_end_time:[], is_all_day:false }
        ],
        buffer_time_unit: '',
        booking_limit: '',
        booking_limit_unit: ''
      },
      data_not_found: false,

      //reading docs
      tableRead: [],
      files: [],
      fileKey: []
    }
  },
  computed: {
  },
  methods: {
    showMultiple(k) {
      this.index = k  // index of imgList
      this.show()
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.view_data.title}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/amenity/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {        
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                this.$router.push({name:'app-amenity-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {              
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.view_data = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    //reading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    async loadData () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/amenity/view/${viewId}`, {
            headers: { 'Authorization': this.token, 'property_ref': localStorage.selectedParentOrgRef }
          })
          .then(res => {     
            if(res['data'] == 'access_denied' || res['data'] == '') {
              this.$vs.notify({
                color: 'danger',
                title: 'Error loading',
                text: 'Something went wrong'
              })
              this.$router.push({name:'app-amenity-list'})
            } else {
              res['data'][0]['operational_days_json'] = JSON.parse(res['data'][0]['operational_days_json'])
              res['data'][0]['inventory_items_json'] = JSON.parse(res['data'][0]['inventory_items_json'])
              resolve(res['data'][0])
            }

            this.$vs.loading.close()
          })
          .catch(err => {
            this.data_not_found = true
            this.$vs.loading.close()
          }) 

          //reading docs
          this.tableRead = await axios.post(`/docs/table/read/`, {
            token: this.token,
            path: `docs/amenity/gallery/${viewId}`,
            document_folder_id: 24
          })

          //reading docs
          for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
            var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
            var imgAsc = imgB64.toString('ascii')
            this.files.push("data:image/png;base64, " + imgAsc)
            this.fileKey.push(value.key)
          }

          console.log('this.files ', this.files)
          console.log('this.fileKey ', this.fileKey)

        } catch(err) {
          reject(err.toString('utf8'));
        }      

        // d.then((res) => {
        //   this.view_data = res[0]
        // })
      })

      this.view_data = await d
      console.log('this.view_data ', this.view_data)

      this.optionHours.filter((res) => {
        this.view_data['min_hours'] = this.view_data['min_hours'] == res['id'] ? res['name'] : this.view_data['min_hours']
        this.view_data['max_hours'] = this.view_data['max_hours'] == res['id'] ? res['name'] : this.view_data['max_hours']
        this.view_data['buffer_time'] = this.view_data['buffer_time'] == res['id'] ? res['name'] : this.view_data['buffer_time']
        this.view_data['booking_limit'] = this.view_data['booking_limit'] == res['id'] ? res['name'] : this.view_data['booking_limit']
      })
    }
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('amenity-list', 'list')
    this.showC = await mainHelper.cansee('amenity-create', 'create')
    this.showR = await mainHelper.cansee('amenity-read', 'read')
    this.showU = await mainHelper.cansee('amenity-update', 'update')
    this.showD = await mainHelper.cansee('amenity-delete', 'delete')

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }
    
    this.loadData()
  }
}

</script>

<style lang="scss">
.vel-modal[data-v-1f17a952] {
  z-index: 100000 !important;
}

#avatar-col {
  width: 10rem;
}

#page-data-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

.avatar-img {
  position: relative;
  width: 230px;
  overflow: hidden;
  padding-top: 230px;
}

.avatar-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
}

div.vx-card__body table td.font-semibold {
  padding-right:30px;
}

div.vs-con-input input[type=color] {
  padding: 0px !important;
  height: 2.5rem !important;
  border-radius: 5px;
}

</style>
